import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Heroimg2 from '../components/Heroimg2'
import Aboutcontent from '../components/Aboutcontent'
import { Helmet } from 'react-helmet-async'


const About = () => {
  return (
    <>
    <Helmet>
      <title>About</title>
      <meta name='description' content={"'Want to download my CV and coverletter and know more about me ?. Click here'"}/>
      <link rel='canonical' href='' />
    </Helmet>
    <div>
      <Navbar/>
      <Heroimg2 
      heading='ABOUT.'
      text='My career journey'/>
      <Aboutcontent />
      <Footer/>
    </div>
      </>
  )
}

export default About